export const validatePhoneNumber = (phoneNumber: string): boolean => {
  const regex = /^\d{3}-\d{4}-\d{4}$|^\d{3}-\d{3}-\d{4}$|^\d{11}$|^\d{10}$/;

  return regex.test(phoneNumber);
};
